(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
  class TestimonialCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.autoplayTimer = null;
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-testimonial-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-testimonial-pagination]'));
      this.prevBtn = this.querySelector('[data-testimonial-prev]');
      this.nextBtn = this.querySelector('[data-testimonial-next]');
      this.count = this.slides.length;

      this.slides.forEach((slide, i) => {
        slide.dataset.index = i;
        slide.setAttribute('aria-label', `${i + 1} of ${this.count}`);
        const active = i === 0;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      if (this.count <= 1) return;

      this.prevBtn?.addEventListener('click', () => this.go(this.currentIndex - 1, true));
      this.nextBtn?.addEventListener('click', () => this.go(this.currentIndex + 1, true));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const idx = parseInt(dot.dataset.index, 10);
          if (!Number.isNaN(idx)) this.go(idx, true);
        });
      });

      this.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.pauseAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());

      this.startAutoplay();
    }

    disconnectedCallback() {
      this.pauseAutoplay();
    }

    go(index, userInitiated = false) {
      const next = ((index % this.count) + this.count) % this.count;
      this.slides.forEach((slide, i) => {
        const active = i === next;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      this.dots.forEach((dot, i) => {
        const active = i === next;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.currentIndex = next;
      if (userInitiated) {
        this.pauseAutoplay();
        this.startAutoplay();
      }
    }

    startAutoplay() {
      this.pauseAutoplay();
      if (this.dataset.autoplay !== 'true') return;
      const speed = parseFloat(this.dataset.autoplaySpeed || '5');
      if (!speed || speed <= 0) return;
      this.autoplayTimer = window.setInterval(() => {
        this.go(this.currentIndex + 1);
      }, speed * 1000);
    }

    pauseAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  if (!customElements.get('testimonial-carousel')) {
    customElements.define('testimonial-carousel', TestimonialCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
